import { createSelector } from 'reselect';
import { getUi, getFeed, getQuery } from './';
import get from 'lodash/get';
import flatten from 'lodash/flatten';
import values from 'lodash/values';
import queryString from 'query-string';

export const selectPlaceFeedChunks = createSelector(
  [getUi, getFeed, getQuery],
  (
    { selectedPlaceId, onlyShowWorkOrders },
    { feedChunkById, feedChunksPagination },
    search,
  ) => {
    const query = onlyShowWorkOrders ? '?kind=workOrder' : '?';
    const feedChunksIds = flatten(
      values(
        get(feedChunksPagination, `[${selectedPlaceId}][${query}].idsByPage`),
      ),
    );

    return feedChunksIds.map(id => feedChunkById[id]);
  },
);

export const selectPlaceFeedChunksPagination = createSelector(
  [getFeed, getUi, getQuery],
  ({ feedChunksPagination }, { selectedPlaceId }, search) => {
    if (search === '') {
      search = '?';
    }

    const { page, ...parsedQuery } = queryString.parse(search);
    const query = `?${queryString.stringify(parsedQuery)}`;

    return get(feedChunksPagination, `${selectedPlaceId}[${query}]`) || {};
  },
);
